(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var state = { scroll: 0, sum: false, disc: null };
    function inner() { return document.querySelector('#cart-drawer [data-cart-inner]'); }
    function applySum(root) {
      var t = root.querySelector('[data-cart-sum-toggle]');
      var b = root.querySelector('[data-cart-sum]');
      if (!t || !b) return;
      b.hidden = !state.sum;
      t.setAttribute('aria-expanded', state.sum ? 'true' : 'false');
    }
    function restore() {
      var root = inner();
      if (!root) return;
      var sc = root.querySelector('[data-cart-scroll]');
      if (sc) sc.scrollTop = state.scroll;
      var d = root.querySelector('details.discount');
      if (d && state.disc === true) d.open = true;
      applySum(root);
    }
    function init() {
      var root = inner();
      if (!root || root.dataset.cartObs) return;
      root.dataset.cartObs = '1';
      new MutationObserver(restore).observe(root, { childList: true });
      applySum(root);
    }
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('#cart-drawer [data-cart-scroll]')) state.scroll = t.scrollTop;
    }, true);
    document.addEventListener('toggle', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('#cart-drawer details.discount')) state.disc = t.open;
    }, true);
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-cart-sum-toggle]');
      if (!t) return;
      e.preventDefault();
      state.sum = !state.sum;
      var root = inner();
      if (root) applySum(root);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-cpage-msg]').forEach(function (t) {
        if (t.dataset.ready) return;
        t.dataset.ready = '1';
        var c = t.parentElement.querySelector('[data-cpage-count]');
        var upd = function () { if (c) c.textContent = t.value.length + '/' + (t.maxLength > 0 ? t.maxLength : 500); };
        t.addEventListener('input', upd); upd();
      });
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-cpage-topic]');
      if (!a) return;
      var sel = document.querySelector('[data-cpage-subject]');
      if (!sel) return;
      var want = a.getAttribute('data-cpage-topic');
      for (var i = 0; i < sel.options.length; i++) { if (sel.options[i].value === want) { sel.selectedIndex = i; break; } }
    });
    function showOk() {
      var ok = document.querySelector('[data-cpage-ok]');
      if (!ok) return;
      ok.scrollIntoView({ block: 'center' });
      try { ok.focus({ preventScroll: true }); } catch (e) {}
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); showOk(); }); else { init(); showOk(); }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const initialMarketSelector = document.querySelector('[data-market-select][data-current-language]');
  if (initialMarketSelector instanceof HTMLSelectElement) {
    const targetLanguage = initialMarketSelector.value === 'US' ? 'en' : 'pt-PT';
    const syncKey = `skutter-locale-sync:${initialMarketSelector.value}:${targetLanguage}`;
    if (initialMarketSelector.dataset.currentLanguage !== targetLanguage && !sessionStorage.getItem(syncKey)) {
      const form = initialMarketSelector.form;
      const language = form?.querySelector('input[name="language_code"]');
      if (form && language instanceof HTMLInputElement) {
        sessionStorage.setItem(syncKey, '1');
        language.value = targetLanguage;
        form.requestSubmit();
      }
    } else if (initialMarketSelector.dataset.currentLanguage === targetLanguage) {
      sessionStorage.removeItem(syncKey);
    }
  }

  document.addEventListener('change', (event) => {
    const selector = event.target;
    if (!(selector instanceof HTMLSelectElement) || !selector.matches('[data-market-select]')) return;
    const form = selector.form;
    if (!form) return;
    const language = form.querySelector('input[name="language_code"]');
    if (language instanceof HTMLInputElement) {
      language.value = selector.selectedOptions[0]?.dataset.language || language.value;
    }
    form.requestSubmit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-videos"] && !Shopify.designMode) return;
  try {
    
function initSkPartners(root){
  const sections=root.matches?.('.sk-partners')?[root]:[...root.querySelectorAll('.sk-partners')];
  sections.forEach(section=>{
    if(section.dataset.ready)return;section.dataset.ready='1';
    const track=section.querySelector('[data-partner-track]');
    const cards=[...section.querySelectorAll('[data-partner-card]')];
    let active=0,timer;
    function sync(card){
      const video=card.querySelector('video');
      card.classList.toggle('is-playing',!video.paused);
      card.classList.toggle('is-unmuted',!video.muted);
      card.querySelector('[data-video-toggle]').setAttribute('aria-label',video.paused?'Reproduzir vídeo':'Pausar vídeo');
      card.querySelector('[data-sound-toggle]').setAttribute('aria-label',video.muted?'Ativar som':'Desativar som');
    }
    function flash(card){
      clearTimeout(card.hideTimer);card.classList.add('is-controls-visible');
      if(!card.querySelector('video').paused)card.hideTimer=setTimeout(()=>card.classList.remove('is-controls-visible'),1000);
    }
    function activate(index){
      active=index;
      cards.forEach((card,i)=>{
        const video=card.querySelector('video');
        if(i===index&&!document.hidden){video.muted=true;video.play().catch(()=>{}).finally(()=>{sync(card);flash(card)})}
        else{video.pause();card.classList.remove('is-controls-visible');sync(card)}
      });
    }
    cards.forEach((card,i)=>{
      const video=card.querySelector('video');
      card.addEventListener('click',event=>{
        if(event.target.closest('[data-sound-toggle]'))return;
        if(video.paused){activate(i)}else{video.pause();flash(card);sync(card)}
      });
      card.addEventListener('pointermove',()=>flash(card));
      card.querySelector('[data-sound-toggle]').addEventListener('click',event=>{
        event.stopPropagation();video.muted=!video.muted;sync(card);
      });
      video.addEventListener('play',()=>sync(card));
      video.addEventListener('pause',()=>sync(card));
      sync(card);
    });
    track.addEventListener('scroll',()=>{
      clearTimeout(timer);timer=setTimeout(()=>{
        const left=track.getBoundingClientRect().left;
        let nearest=0,distance=Infinity;
        cards.forEach((card,i)=>{const d=Math.abs(card.getBoundingClientRect().left-left);if(d<distance){distance=d;nearest=i}});
        if(nearest!==active)activate(nearest);
      },120);
    },{passive:true});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)cards.forEach(c=>c.querySelector('video').pause())});
    if(cards.length){const observer=new IntersectionObserver(entries=>{
      if(entries[0].isIntersecting){activate(0);observer.disconnect()}
    },{threshold:.25});observer.observe(section)}
  });
}
document.addEventListener('DOMContentLoaded',()=>initSkPartners(document));
document.addEventListener('shopify:section:load',event=>initSkPartners(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-bundle-buy]');if(!button)return;const root=button.closest('[data-product]');if(!root)return;const form=root.querySelector('[data-product-form]');if(form){form.dataset.bundleSubmit='true';form.requestSubmit()}})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-community-reference"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  var button=event.target.closest('[data-review-prev],[data-review-next]');
  if(!button)return;
  var section=button.closest('.customer-reviews');
  var track=section&&section.querySelector('[data-review-track]');
  var card=track&&track.querySelector('.customer-review');
  if(!card)return;
  track.scrollBy({left:(card.getBoundingClientRect().width+15)*(button.hasAttribute('data-review-next')?1:-1),behavior:'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-compare"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){const button=e.target.closest('[data-cmp-edit]');if(!button)return;const head=button.closest('[data-cmp-col]');const select=head.querySelector('[data-cmp-select]');select.hidden=false;select.focus()});
document.addEventListener('change',function(e){const select=e.target.closest('[data-cmp-select]');if(!select)return;const table=select.closest('.cmp');const head=select.closest('[data-cmp-col]');const col=head.dataset.cmpCol;const option=select.selectedOptions[0];if(!option)return;const link=head.querySelector('[data-cmp-link]');link.href=option.dataset.link;const img=link.querySelector('img');if(img){img.src=option.dataset.image;img.srcset='';img.alt=option.dataset.title}head.querySelector('[data-cmp-name]').textContent=option.dataset.title;head.querySelector('[data-cmp-edit]').setAttribute('aria-label','Alterar modelo '+option.dataset.title);const specs=[option.dataset.motor,option.dataset.range,option.dataset.speed,option.dataset.tyres,option.dataset.suspension];specs.forEach((value,index)=>{const cell=table.querySelector('[data-cmp-value-col="'+col+'"][data-cmp-spec="'+index+'"]');if(!cell)return;if(index===1)value=value?'até '+value:'—';else if(index===4)value={dupla:'✓ Dupla',frente:'✓ Frontal',tras:'✓ Traseira',nao:'—'}[value]||'—';cell.textContent=value||'—'});const price=table.querySelector('[data-cmp-value-col="'+col+'"][data-cmp-price]');if(price)price.textContent=option.dataset.price;select.hidden=true});
document.addEventListener('focusout',function(e){if(!e.target.matches('[data-cmp-select]'))return;setTimeout(()=>{e.target.hidden=true},180)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-savings-calculator"] && !Shopify.designMode) return;
  try {
    
(function(){
  function euro(v,dec){
    var n=Number(v)||0;
    var s=n.toLocaleString('pt-PT',{minimumFractionDigits:dec||0,maximumFractionDigits:dec||0});
    return '€'+s;
  }
  function parseNum(s){
    if(typeof s==='number')return s;
    s=String(s||'').replace(/\s/g,'').replace('€','');
    if(s.indexOf(',')>-1)s=s.replace(/\./g,'').replace(',','.');
    var n=parseFloat(s);return isNaN(n)?0:n;
  }
  /* "519 €", "1.299 €", "1.299,90 €" -> número */
  function parseMoney(v){
    if(typeof v==='number')return v;
    var t=String(v).replace(/[^\d,.]/g,'');
    if(/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(t)||t.indexOf(',')>-1)t=t.replace(/\./g,'').replace(',','.');
    var n=parseFloat(t);return isNaN(n)?0:n;
  }
  function fmt(n,dec){return Number(n).toLocaleString('pt-PT',{minimumFractionDigits:dec,maximumFractionDigits:dec,useGrouping:false})}
  /* Slider com marcas igualmente espaçadas (escala por troços, como no design) */
  function toPos(v,stops){
    var seg=400/(stops.length-1);
    if(v<=stops[0])return 0;
    for(var i=1;i<stops.length;i++){
      if(v<=stops[i])return Math.round((i-1)*seg+(v-stops[i-1])/(stops[i]-stops[i-1])*seg);
    }
    return 400;
  }
  function fromPos(p,stops){
    var seg=400/(stops.length-1),i=Math.min(stops.length-2,Math.floor(p/seg));
    return stops[i]+(p-i*seg)/seg*(stops[i+1]-stops[i]);
  }
  function roundTo(v,dec){
    if(dec===0)return Math.round(v);
    if(dec===2)return Math.round(v*20)/20; /* passos de 0,05 € */
    return Math.round(v*10)/10;
  }

  function init(root){
    if(root.dataset.ready)return;root.dataset.ready='1';
    var state={step:0,price:(Number(root.dataset.price)||0)/100,days:Number(root.dataset.days)||26,charge:(Number(root.dataset.charge)||15)/100};
    var screens=root.querySelectorAll('[data-screen]'),nav=root.querySelector('[data-nav]');
    var fields={};

    root.querySelectorAll('[data-field]').forEach(function(f){
      var stops=f.dataset.stops.split(',').map(Number),dec=Number(f.dataset.decimals)||0;
      var input=f.querySelector('[data-input]'),range=f.querySelector('[data-range]');
      var item={value:Number(f.dataset.value),stops:stops,dec:dec,input:input,range:range};
      function paintRange(){range.style.setProperty('--fill',(range.value/4)+'%')}
      item.set=function(v,fromRange){
        item.value=Math.max(0,v);
        if(!fromRange)range.value=toPos(item.value,stops);
        if(document.activeElement!==input)input.value=fmt(item.value,dec===2?2:dec);
        paintRange();
      };
      range.addEventListener('input',function(){item.set(roundTo(fromPos(Number(range.value),stops),dec),true);input.value=fmt(item.value,dec===2?2:dec)});
      input.addEventListener('input',function(){var v=parseNum(input.value);item.value=Math.max(0,v);range.value=toPos(item.value,stops);paintRange()});
      input.addEventListener('blur',function(){input.value=fmt(item.value,dec===2?2:dec)});
      item.set(item.value);
      fields[f.dataset.field]=item;
    });

    /* Preço */
    var priceDisplay=root.querySelector('[data-price-display]'),priceEdit=root.querySelector('[data-price-edit]'),priceInput=root.querySelector('[data-price-input]'),priceToggle=root.querySelector('[data-price-toggle]');
    var priceTouched=false;
    function paintPrice(){priceDisplay.textContent=euro(state.price,state.price%1?2:0)}
    priceToggle.addEventListener('click',function(){
      var open=priceEdit.hidden;priceEdit.hidden=!open;
      priceToggle.querySelector('span').textContent=open?'Guardar valor':'Alterar valor';
      if(open){priceInput.value=fmt(state.price,state.price%1?2:0);priceInput.focus();priceInput.select()}
      else{var v=parseNum(priceInput.value);if(v>0){state.price=v;priceTouched=true}paintPrice()}
    });
    priceInput.addEventListener('input',function(){var v=parseNum(priceInput.value);if(v>0){state.price=v;priceTouched=true;paintPrice()}});
    priceInput.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();priceToggle.click()}});
    paintPrice();
    /* Acompanha a variante escolhida na página (se o cliente não alterou o valor) */
    document.addEventListener('change',function(e){
      if(priceTouched||!e.target.closest('[data-variant-picker]'))return;
      setTimeout(function(){
        var json=document.querySelector('[data-product-json]'),idInput=document.querySelector('[data-variant-id]');
        if(!json||!idInput)return;
        try{var data=JSON.parse(json.textContent);var list=data.variants||data;var v=(list||[]).find(function(x){return String(x.id)===String(idInput.value)});
          if(v&&v.price){var pr=parseMoney(v.price);if(pr>0){state.price=pr;paintPrice()}}}catch(err){}
      },60);
    });

    var chargeTxt='~ '+euro(state.charge,2);
    root.querySelector('[data-charge-display]').textContent=chargeTxt;
    root.querySelector('[data-charge-note]').textContent=euro(state.charge,2);
    var info=root.querySelector('[data-info]'),infoText=root.querySelector('[data-info-text]');
    info.addEventListener('click',function(){infoText.hidden=!infoText.hidden;info.setAttribute('aria-expanded',String(!infoText.hidden))});

    function calc(){
      var km=fields.km.value,cons=fields.consumption.value,fuel=fields.fuel.value;
      var monthKm=km*state.days;
      var car=monthKm*cons/100*fuel;
      var scooter=monthKm*state.charge/100;
      var save=car-scooter;
      var months=save>0?Math.ceil(state.price/save):0;
      return {car:car,scooter:scooter,save:save,months:months};
    }
    function paintResult(){
      var r=calc(),set=function(sel,t){root.querySelectorAll(sel).forEach(function(n){n.textContent=t})};
      var monthsTxt=r.months>0?(r.months+' '+(r.months===1?'mês':'meses')):'—';
      set('[data-months]',monthsTxt);set('[data-months-inline]',monthsTxt);
      root.querySelector('[data-nosave]').hidden=r.save>0;
      set('[data-save-month]',euro(Math.max(0,Math.round(r.save))));
      set('[data-save-month-inline]',euro(Math.max(0,Math.round(r.save))));
      set('[data-save-year]',euro(Math.max(0,Math.round(r.save)*12)));
      set('[data-car-month]',euro(Math.round(r.car))+'/mês');
      set('[data-scooter-month]',(r.scooter<10?euro(r.scooter,2):euro(Math.round(r.scooter)))+'/mês');
      var y3=Math.max(0,Math.round(r.save*36));
      set('[data-save-3y]',euro(y3));
      var net=Math.round(r.save*36-state.price);
      set('[data-save-3y-net]',net>0?('Já descontando o preço da trotinete, ficas com '+euro(net)+' no bolso.'):'Em combustível, face ao carro.');
    }
    function go(step){
      state.step=step;
      screens.forEach(function(s){s.classList.toggle('is-active',Number(s.dataset.screen)===step)});
      nav.hidden=step===0;
      root.querySelectorAll('[data-step-dot]').forEach(function(d){
        var n=Number(d.dataset.stepDot);
        d.classList.toggle('is-done',n<step);d.classList.toggle('is-current',n===step);
        if(n===step)d.setAttribute('aria-current','step');else d.removeAttribute('aria-current');
      });
      if(step>=3)paintResult();
      var top=root.getBoundingClientRect().top;
      if(top<0||top>window.innerHeight*.6)root.scrollIntoView({behavior:'smooth',block:'start'});
    }
    root.addEventListener('click',function(e){
      var g=e.target.closest('[data-go]');if(g){go(Number(g.dataset.go));return}
      if(e.target.closest('[data-back]'))go(Math.max(0,state.step-1));
    });
    var buy=root.querySelector('[data-buy-link]');
    if(buy)buy.addEventListener('click',function(e){
      var target=document.querySelector(buy.getAttribute('href'))||document.querySelector('[data-product-form]');
      if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'center'})}
    });
  }
  function all(){document.querySelectorAll('[data-savings-calc]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
function initSkReviews(root){
  const sections=root.matches?.('.sk-reviews')?[root]:[...root.querySelectorAll('.sk-reviews')];
  sections.forEach(section=>{
    if(section.dataset.ready)return;section.dataset.ready='1';
    const track=section.querySelector('[data-review-track]');
    const slides=[...section.querySelectorAll('.sk-reviews__slide')];
    const dots=[...section.querySelectorAll('[data-review-dot]')];
    function update(){
      if(!slides.length)return;
      const left=track.getBoundingClientRect().left;
      let closest=0,delta=Infinity;
      slides.forEach((slide,i)=>{const d=Math.abs(slide.getBoundingClientRect().left-left);if(d<delta){delta=d;closest=i}});
      if(track.scrollLeft<4)closest=0;
      if(track.scrollLeft>=track.scrollWidth-track.clientWidth-4)closest=slides.length-1;
      dots.forEach((dot,i)=>{if(i===closest)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});
    }
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>track.scrollTo({left:slides[i].offsetLeft-slides[0].offsetLeft,behavior:'smooth'})));
    track.addEventListener('scroll',update,{passive:true});update();
  });
}
document.addEventListener('DOMContentLoaded',()=>initSkReviews(document));
document.addEventListener('shopify:section:load',event=>initSkReviews(event.target));

  } catch(e) { console.error(e); }
})();
})();
